var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"ic_keyboard_arrow_left_24px","d":"M6.175,1.175,2.358,5,6.175,8.825,5,10,0,5,5,0Z","transform":"translate(10) rotate(90)"}));
}

ChevronUp.defaultProps = {"width":"10","height":"6.175","viewBox":"0 0 10 6.175"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
